export const ACTION_TYPE_PURGE_ALL = 1;
export const ACTION_TYPE_PURGE_FORMULA = 2;
export const ACTION_TYPE_BRUSH_MAINTENANCE = 3;
export const ACTION_TYPE_CAP_MAINTENANCE = 4;
export const ACTION_TYPE_SWITCH_PLATE_MAINTENANCE = 5;
export const ACTION_TYPE_DISPENSER_CLEANING = 6;
export const ACTION_TYPE_HUMIDIFIER_WATER_LEVEL_MAINTENANCE = 7;
export const ACTION_TYPE_REFILL_ALL_MAINTENANCE = 8;
export const ACTION_TYPE_REFILL_CANISTERS_MAINTENANCE = 9;
export const ACTION_TYPE_COMPUTER_REBOOT = 10;
export const ACTION_TYPE_COMPUTER_SHUTDOWN = 11;
export const ACTION_TYPE_CLEAN_ALL = 12;
export const ACTION_TYPE_CLEAN_CHANNELS = 13;
export const ACTION_TYPE_RECIRCULATE_ALL = 14;
export const ACTION_TYPE_RECIRCULATE_CHANNELS = 15;
export const ACTION_TYPE_STIR_ALL = 16;
export const ACTION_TYPE_STIR_CANISTERS = 17;
export const ACTION_TYPE_SMART_PURGE_ALL = 18;
export const ACTION_TYPE_SMART_PURGE_CHANNELS = 19;

export const ACTION_TYPES_SORTED = [2, 1, 19, 18, 13, 12, 15, 14, 17, 16, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export const ACTION_TYPES_COMPUTER = [10, 11];
export const ACTION_TYPES_SERVICE_ACTIONS = [12, 13, 1, 2, 14, 15, 8, 9, 18, 19, 16, 17];
export const ACTION_TYPES_MAINTENANCE = [3, 4, 6, 7, 5];

export const START_TYPE_ON_START = 1;
export const START_TYPE_RUN_AT = 2;
export const START_TYPE_RUN_EVERY = 3;
export const START_TYPE_DEFINED_DAYS_AT = 4;

export const DAYS_OF_MONTH = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
];
export const MONDAY = 0;
export const TUESDAY = 1;
export const WEDNESDAY = 2;
export const THURSDAY = 3;
export const FRIDAY = 4;
export const SATURDAY = 5;
export const SUNDAY = 6;
export const WEEKDAYS = [MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY, SUNDAY];
